export default __webpack_public_path__ + "static/media/fh-logo.32c9b398.png";